(function () {
  'use strict';

  if (window.__OEMBuildKitInitialized) return;
  window.__OEMBuildKitInitialized = true;

  /* ─── Lucide SVG Paths (viewBox 0 0 24 24, stroke-based) ──────────── */

  var ICONS = {
    package: '<path d="M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z"/><path d="M12 22V12"/><path d="m3.3 7 7.703 4.734a2 2 0 0 0 1.994 0L20.7 7"/><path d="m7.5 4.27 9 5.15"/>',
    spraycan: '<path d="M3 3h.01"/><path d="M7 5h.01"/><path d="M11 7h.01"/><path d="M3 7h.01"/><path d="M7 9h.01"/><path d="M3 11h.01"/><rect width="4" height="4" x="15" y="5"/><path d="m19 9 2 2v10c0 .6-.4 1-1 1h-6c-.6 0-1-.4-1-1V11l2-2"/><path d="m13 14 8-2"/><path d="m13 19 8-2"/>',
    component: '<path d="M5.5 8.5 9 12l-3.5 3.5L2 12l3.5-3.5Z"/><path d="m12 2 3.5 3.5L12 9 8.5 5.5 12 2Z"/><path d="M18.5 8.5 22 12l-3.5 3.5L15 12l3.5-3.5Z"/><path d="m12 15 3.5 3.5L12 22l-3.5-3.5L12 15Z"/>',
    layoutgrid: '<path d="M4 5a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1l0 -4"/><path d="M14 5a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1l0 -4"/><path d="M4 15a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1l0 -4"/><path d="M14 15a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1l0 -4"/>',
    tblspray: '<path d="M4 12a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2v7a2 2 0 0 1 -2 2h-4a2 2 0 0 1 -2 -2l0 -7"/><path d="M6 10v-4a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v4"/><path d="M15 7h.01"/><path d="M18 9h.01"/><path d="M18 5h.01"/><path d="M21 3h.01"/><path d="M21 7h.01"/><path d="M21 11h.01"/><path d="M10 7h1"/>',
    tblcarcrash: '<path d="M8 17a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"/><path d="M7 6l4 5h1a2 2 0 0 1 2 2v4h-2m-4 0h-5m0 -6h8m-6 0v-5m2 0h-4"/><path d="M14 8v-2"/><path d="M19 12h2"/><path d="M17.5 15.5l1.5 1.5"/><path d="M17.5 8.5l1.5 -1.5"/>',
    tbltool: '<path d="M7 10h3v-3l-3.5 -3.5a6 6 0 0 1 8 8l6 6a2 2 0 0 1 -3 3l-6 -6a6 6 0 0 1 -8 -8l3.5 3.5"/>',
    tblcardoor: '<path d="M13 14h2"/><path d="M19 10h-16"/><path d="M6.7 3.45l-3.7 5.55v3.08a1 1 0 0 0 .85 1a6 6 0 0 1 5.15 5.92v1a1 1 0 0 0 1 1h8a1 1 0 0 0 1 -1v-16a1 1 0 0 0 -1 -1h-10.46a1 1 0 0 0 -.84 .45"/>',
    tblcar: '<path d="M5 17a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"/><path d="M15 17a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"/><path d="M5 17h-2v-6l2 -5h9l4 5h1a2 2 0 0 1 2 2v4h-2m-4 0h-6m-6 -6h15m-6 0v-5"/>',
    tblwheel: '<path d="M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"/><path d="M9 12a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"/><path d="M3 12h6"/><path d="M15 12h6"/><path d="M13.6 9.4l3.4 -4.8"/><path d="M10.4 14.6l-3.4 4.8"/><path d="M7 4.6l3.4 4.8"/><path d="M13.6 14.6l3.4 4.8"/>',
    tblmotorbike: '<path d="M2 16a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"/><path d="M16 16a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"/><path d="M7.5 14h5l4 -4h-10.5m1.5 4l4 -4"/><path d="M13 6h2l1.5 3l2 4"/>',
    check: '<path d="M20 6 9 17l-5-5"/>',
    arrowright: '<path d="M5 12h14"/><path d="m12 5 7 7-7 7"/>',
    chevronright: '<path d="m9 18 6-6-6-6"/>',
    chevronleft: '<path d="m15 18-6-6 6-6"/>',
    x: '<path d="M18 6 6 18"/><path d="m6 6 12 12"/>',
    info: '<circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/>',
    plus: '<path d="M5 12h14"/><path d="M12 5v14"/>',
    camera: '<path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z"/><circle cx="12" cy="13" r="3"/>',
    sparkles: '<path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z"/>',
    alertcircle: '<circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>',
    loader: '<path d="M12 2v4"/><path d="m16.2 7.8 2.9-2.9"/><path d="M18 12h4"/><path d="m16.2 16.2 2.9 2.9"/><path d="M12 18v4"/><path d="m4.9 19.1 2.9-2.9"/><path d="M2 12h4"/><path d="m4.9 4.9 2.9 2.9"/>',
    shoppingcart: '<circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/>'
  };

  function svg(name, w, h) {
    var size = w || 20;
    var sh = h || size;
    // Stroke-based icons (Lucide + Tabler, both viewBox 24 / stroke-width 2)
    return '<svg xmlns="http://www.w3.org/2000/svg" width="' + size + '" height="' + sh + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' + (ICONS[name] || '') + '</svg>';
  }

  /* ─── API Base ──────────────────────────────────────────────────────── */

  var API_BASE = 'https://dyc-ai-search.vercel.app';

  /* ─── Top-Level Project Types (shown in main grid) ─────────────────── */

  var PROJECT_TYPES = [
    { id: 'chip_scratch',         icon: 'tblspray',   title: 'Chip / Scratch',   desc: 'Small touch-ups',    popular: true },
    { id: 'bumper_bare',          icon: 'tblcarcrash', title: 'Bumper',           desc: 'Bare plastic' },
    { id: 'bumper_repair',        icon: 'tblcarcrash', title: 'Bumper',           desc: 'Repair damage',      popular: true },
    { id: 'bumper_respray',       icon: 'tblcarcrash', title: 'Bumper',           desc: 'Respray only' },
    { id: 'small_repair',         icon: 'tbltool',     title: 'Small Repair',     desc: 'Mirrors & trim' },
    { id: 'single_panel_bare',    icon: 'tblcardoor', title: 'Single Panel',     desc: 'Bare metal' },
    { id: 'single_panel_repair',  icon: 'tblcardoor', title: 'Single Panel',     desc: 'Repair' },
    { id: 'single_panel_respray', icon: 'tblcardoor', title: 'Single Panel',     desc: 'Respray' },
    { id: 'multiple_panels',      icon: 'layoutgrid', title: 'Multiple Panels',  desc: '2-3 panels' },
    { id: 'full_vehicle',         icon: 'tblcar',     title: 'Full Vehicle',     desc: 'Complete car',       popular: true },
    { id: 'wheels',               icon: 'tblwheel',   title: 'Wheels',           desc: 'Rims & wheels',      popular: true },
    { id: 'motorcycle',           icon: 'tblmotorbike', title: 'Motorcycle',       desc: 'Bike parts' }
  ];

  /* ─── Sub-Type Chips (shown after selecting a parent type) ─────────── */

  var SUB_TYPES = {
    full_vehicle: {
      prompt: 'What size vehicle?',
      layout: 'image-grid',
      chips: [
        { key: 'full_vehicle_small',  label: 'Small',  desc: 'ATVs, Golf Carts, Side-by-Sides', image: 'https://cdn.shopify.com/s/files/1/0973/6008/files/small.webp?v=1757961794' },
        { key: 'full_vehicle_medium', label: 'Medium', desc: 'Civic, Mustang, Focus, BMW 3', image: 'https://cdn.shopify.com/s/files/1/0973/6008/files/medium.webp?v=1757961794' },
        { key: 'full_vehicle_large',  label: 'Large',  desc: 'BMW 5 Series, S-Class, Audi A6', image: 'https://cdn.shopify.com/s/files/1/0973/6008/files/large.webp?v=1757961794' },
        { key: 'full_vehicle_xl',     label: 'XL',     desc: 'F-150, Suburban, X7, Tahoe', image: 'https://cdn.shopify.com/s/files/1/0973/6008/files/xl.webp?v=1757961794' }
      ]
    },
    motorcycle: {
      prompt: 'What are you painting?',
      chips: [
        { key: 'motorcycle_few_parts', label: 'A Few Parts',          desc: 'Tank, fender, or a couple small pieces' },
        { key: 'motorcycle_sport',     label: 'Sports Bike Fairings', desc: 'Full fairing set' },
        { key: 'motorcycle_tourer',    label: 'Tourer with Storage',  desc: 'Panniers, side cases, extra bodywork' }
      ]
    }
  };

  /* ─── Size Guide (all terminal project types) ──────────────────────── */

  var SIZE_GUIDE = {
    chip_scratch:         { size: '2oz',     cartItems: null, text: 'For small scratches and chips, the 2oz 1K Gloss touch-up bottle is perfect: it dries glossy straight from the bottle, no clearcoat needed. Built-in brush applicator.' },
    bumper_bare:          { size: 'Aerosol', cartItems: [{ sizeOption: 'Aerosol', quantity: 2 }], text: 'For a bare plastic bumper, 2 aerosol cans cover multiple coats. We pre-selected epoxy primer and adhesion promoter for proper adhesion.' },
    bumper_repair:        { size: 'Aerosol', cartItems: [{ sizeOption: 'Aerosol', quantity: 2 }], text: 'For a bumper repair with damage, 2 aerosol cans cover multiple coats. We pre-selected primer filler to smooth imperfections.' },
    bumper_respray:       { size: 'Aerosol', cartItems: [{ sizeOption: 'Aerosol', quantity: 2 }], text: 'For a clean bumper respray (no damage), 2 aerosol cans cover multiple coats. No primer needed for existing paint.' },
    small_repair:         { size: '4oz',     cartItems: null, text: 'Ideal for mirrors, trim pieces, small blend areas, or small motorcycle parts. Not recommended for full-size panels.' },
    single_panel_bare:    { size: 'Pint',    cartItems: null, text: 'For a single panel with bare metal, a pint provides enough material for 2\u20133 coats. We pre-selected epoxy primer for adhesion.' },
    single_panel_repair:  { size: 'Pint',    cartItems: null, text: 'For a single panel repair with scratches/dents, a pint provides enough material for 2\u20133 coats. We pre-selected primer filler to smooth imperfections.' },
    single_panel_respray: { size: 'Pint',    cartItems: null, text: 'For a clean single panel respray (no damage), a pint provides enough material for 2\u20133 coats. No primer needed for existing paint.' },
    multiple_panels:      { size: 'Quart',   cartItems: null, text: 'A quart safely covers two full panels or multiple smaller panels with proper coat coverage. Add primer if you have bare metal, dents, or imperfections.' },
    full_vehicle_small:   { size: 'Quart',   cartItems: [{ sizeOption: 'Quart', quantity: 2 }], text: 'For a small vehicle like an ATV or golf cart, two quarts of basecoat gives you enough for 2\u20133 even coats.' },
    full_vehicle_medium:  { size: 'Gallon',  cartItems: [{ sizeOption: 'Gallon', quantity: 1 }, { sizeOption: 'Quart', quantity: 1 }], text: 'A gallon plus an additional quart ensures full coverage for most mid-size cars with 2\u20133 coats, including metallic and pearl colors.' },
    full_vehicle_large:   { size: 'Gallon',  cartItems: [{ sizeOption: 'Gallon', quantity: 1 }, { sizeOption: 'Quart', quantity: 2 }], text: 'For a large sedan, you\u2019ll need a gallon plus two extra quarts of basecoat. One clearcoat kit covers the full car.' },
    full_vehicle_xl:      { size: 'Gallon',  cartItems: [{ sizeOption: 'Gallon', quantity: 2 }, { sizeOption: 'Quart', quantity: 1 }], text: 'Full-size trucks and SUVs often need two gallons plus an extra quart for 2\u20133 coats, especially on large cabs, bedsides, and high-roof bodies.' },
    wheels:               { size: 'Aerosol', cartItems: [{ sizeOption: 'Aerosol', quantity: 4 }], text: 'For a set of 4 wheels, you\u2019ll need 4 aerosol cans of basecoat plus clearcoat. Our wheel kits come pre-packaged with everything you need.' },
    motorcycle_few_parts: { size: 'Aerosol', cartItems: null, text: 'For a few small motorcycle parts, one aerosol can is usually enough for proper coverage. Add aerosol clearcoat for protection.' },
    motorcycle_sport:     { size: 'Pint',    cartItems: null, text: 'For a full sport bike fairing set, a pint provides enough material for 2\u20133 coats with normal overspray. Add clearcoat for protection.' },
    motorcycle_tourer:    { size: 'Quart',   cartItems: [{ sizeOption: 'Quart', quantity: 1 }, { sizeOption: '4oz', quantity: 1 }], text: 'Touring bikes with storage/panniers have more surface area. A quart plus an extra 4oz gives safe coverage for 2\u20133 coats.' }
  };

  /* ─── Kit Product Rules (per terminal type) ────────────────────────── */
  /* Each entry: { name, desc, preSelect, quantity } */
  /* These are display-only until the addons API provides real product data */

  var KIT_RULES = {
    chip_scratch: [
      { name: 'Luna 1K Clearcoat Pen',             desc: 'Seal and protect your touch-up',          preSelect: true },
      { name: 'Luna Grey Scuff Pads (Pack of 3)',   desc: 'Surface prep and scuffing',               preSelect: true },
      { name: 'Q1 Masking Tape 1.5"',               desc: 'For clean paint lines',                   preSelect: false },
      { name: 'Q1 Masking Tape 3/4"',               desc: 'For tight curves and detail work',        preSelect: false },
      { name: 'Tape and Drape',                     desc: 'Protect surrounding areas',               preSelect: false },
      { name: '3M Respirator',                      desc: 'Protect yourself from fumes',             preSelect: false }
    ],
    bumper_bare: [
      { name: 'Luna 2K Clearcoat Aerosol',          desc: 'Protection + high gloss finish',          preSelect: true },
      { name: 'Luna Grey Scuff Pads (Pack of 3)',   desc: 'Surface prep and scuffing',               preSelect: true },
      { name: 'Luna 1KEpoxy Primer Aerosol',        desc: 'For bare metal or raw plastic',           preSelect: true },
      { name: 'Adhesion Promoter / UltraGrip',      desc: 'Essential for plastic bumpers',           preSelect: true },
      { name: 'Luna XPressBuild Primer Filler',     desc: 'Fills scratches and imperfections',       preSelect: false },
      { name: 'Luna ProMatt Clear Aerosol',         desc: 'For a matte/satin finish instead',        preSelect: false },
      { name: 'Q1 Masking Tape 1.5"',               desc: 'For clean paint lines',                   preSelect: false },
      { name: 'Q1 Masking Tape 3/4"',               desc: 'For tight curves and detail work',        preSelect: false },
      { name: 'Tape and Drape',                     desc: 'Protect surrounding areas',               preSelect: false },
      { name: '3M Respirator',                      desc: 'Protect yourself from fumes',             preSelect: false }
    ],
    bumper_repair: [
      { name: 'Luna 2K Clearcoat Aerosol',          desc: 'Protection + high gloss finish',          preSelect: true },
      { name: 'Luna Grey Scuff Pads (Pack of 3)',   desc: 'Surface prep and scuffing',               preSelect: true },
      { name: 'Luna XPressBuild Primer Filler',     desc: 'Fills scratches and imperfections',       preSelect: true },
      { name: 'Luna 1KEpoxy Primer Aerosol',        desc: 'For bare metal or raw plastic',           preSelect: false },
      { name: 'Adhesion Promoter / UltraGrip',      desc: 'Essential for plastic bumpers',           preSelect: false },
      { name: 'Luna ProMatt Clear Aerosol',         desc: 'For a matte/satin finish instead',        preSelect: false },
      { name: 'Q1 Masking Tape 1.5"',               desc: 'For clean paint lines',                   preSelect: false },
      { name: 'Q1 Masking Tape 3/4"',               desc: 'For tight curves and detail work',        preSelect: false },
      { name: 'Tape and Drape',                     desc: 'Protect surrounding areas',               preSelect: false },
      { name: '3M Respirator',                      desc: 'Protect yourself from fumes',             preSelect: false }
    ],
    bumper_respray: [
      { name: 'Luna 2K Clearcoat Aerosol',          desc: 'Protection + high gloss finish',          preSelect: true },
      { name: 'Luna Grey Scuff Pads (Pack of 3)',   desc: 'Surface prep and scuffing',               preSelect: true },
      { name: 'Luna 1KEpoxy Primer Aerosol',        desc: 'For bare metal or raw plastic',           preSelect: false },
      { name: 'Luna XPressBuild Primer Filler',     desc: 'Fills scratches and imperfections',       preSelect: false },
      { name: 'Adhesion Promoter / UltraGrip',      desc: 'Essential for plastic bumpers',           preSelect: false },
      { name: 'Luna ProMatt Clear Aerosol',         desc: 'For a matte/satin finish instead',        preSelect: false },
      { name: 'Q1 Masking Tape 1.5"',               desc: 'For clean paint lines',                   preSelect: false },
      { name: 'Q1 Masking Tape 3/4"',               desc: 'For tight curves and detail work',        preSelect: false },
      { name: 'Tape and Drape',                     desc: 'Protect surrounding areas',               preSelect: false },
      { name: '3M Respirator',                      desc: 'Protect yourself from fumes',             preSelect: false }
    ],
    small_repair: [
      { name: 'Luna 2K Clearcoat Aerosol',          desc: 'Protection + high gloss finish',          preSelect: true },
      { name: 'Preval Sprayer',                     desc: 'Turns your 4oz bottle into a spray can',  preSelect: true },
      { name: 'Luna Grey Scuff Pads (Pack of 3)',   desc: 'Surface prep and scuffing',               preSelect: true },
      { name: 'Luna XPressBuild Primer Filler',     desc: 'Fills scratches and imperfections',       preSelect: true },
      { name: 'Luna 1KEpoxy Primer Aerosol',        desc: 'For bare metal or raw plastic',           preSelect: false },
      { name: 'Adhesion Promoter / UltraGrip',      desc: 'For plastic or smooth surfaces',          preSelect: false },
      { name: 'Luna ProMatt Clear Aerosol',         desc: 'For a matte/satin finish instead',        preSelect: false },
      { name: 'Q1 Masking Tape 1.5"',               desc: 'For clean paint lines',                   preSelect: false },
      { name: 'Q1 Masking Tape 3/4"',               desc: 'For tight curves and detail work',        preSelect: false },
      { name: 'Tape and Drape',                     desc: 'Protect surrounding areas',               preSelect: false },
      { name: '3M Respirator',                      desc: 'Protect yourself from fumes',             preSelect: false }
    ],
    single_panel_bare: [
      { name: 'Luna Standard Clearcoat 4.7L Kit',   desc: 'Good durability, affordable option',      preSelect: true },
      { name: 'Luna VHS Crystal Clearcoat 5L Kit',  desc: 'Premium \u2014 deep gloss, superior leveling', preSelect: false },
      { name: 'Luna Grey Scuff Pads (Pack of 3)',   desc: 'Surface prep and scuffing',               preSelect: true },
      { name: 'Luna 1KEpoxy Primer Aerosol',        desc: 'For bare metal or raw plastic',           preSelect: true },
      { name: 'Luna XPressBuild Primer Filler',     desc: 'Fills scratches and imperfections',       preSelect: false },
      { name: 'Adhesion Promoter / UltraGrip',      desc: 'For plastic or smooth surfaces',          preSelect: false },
      { name: 'Q1 Masking Tape 1.5"',               desc: 'For clean paint lines',                   preSelect: false },
      { name: 'Q1 Masking Tape 3/4"',               desc: 'For tight curves and detail work',        preSelect: false },
      { name: 'Tape and Drape',                     desc: 'Protect surrounding areas',               preSelect: false },
      { name: '3M Respirator',                      desc: 'Protect yourself from fumes',             preSelect: false }
    ],
    single_panel_repair: [
      { name: 'Luna Standard Clearcoat 4.7L Kit',   desc: 'Good durability, affordable option',      preSelect: true },
      { name: 'Luna VHS Crystal Clearcoat 5L Kit',  desc: 'Premium \u2014 deep gloss, superior leveling', preSelect: false },
      { name: 'Luna Grey Scuff Pads (Pack of 3)',   desc: 'Surface prep and scuffing',               preSelect: true },
      { name: 'Luna XPressBuild Primer Filler',     desc: 'Fills scratches and imperfections',       preSelect: true },
      { name: 'Luna 1KEpoxy Primer Aerosol',        desc: 'For bare metal or raw plastic',           preSelect: false },
      { name: 'Adhesion Promoter / UltraGrip',      desc: 'For plastic or smooth surfaces',          preSelect: false },
      { name: 'Q1 Masking Tape 1.5"',               desc: 'For clean paint lines',                   preSelect: false },
      { name: 'Q1 Masking Tape 3/4"',               desc: 'For tight curves and detail work',        preSelect: false },
      { name: 'Tape and Drape',                     desc: 'Protect surrounding areas',               preSelect: false },
      { name: '3M Respirator',                      desc: 'Protect yourself from fumes',             preSelect: false }
    ],
    single_panel_respray: [
      { name: 'Luna Standard Clearcoat 4.7L Kit',   desc: 'Good durability, affordable option',      preSelect: true },
      { name: 'Luna VHS Crystal Clearcoat 5L Kit',  desc: 'Premium \u2014 deep gloss, superior leveling', preSelect: false },
      { name: 'Luna Grey Scuff Pads (Pack of 3)',   desc: 'Surface prep and scuffing',               preSelect: true },
      { name: 'Q1 Masking Tape 1.5"',               desc: 'For clean paint lines',                   preSelect: false },
      { name: 'Q1 Masking Tape 3/4"',               desc: 'For tight curves and detail work',        preSelect: false },
      { name: 'Tape and Drape',                     desc: 'Protect surrounding areas',               preSelect: false },
      { name: '3M Respirator',                      desc: 'Protect yourself from fumes',             preSelect: false }
    ],
    multiple_panels: [
      { name: 'Luna Standard Clearcoat 4.7L Kit',   desc: 'Good durability, affordable option',      preSelect: true },
      { name: 'Luna VHS Crystal Clearcoat 5L Kit',  desc: 'Premium \u2014 deep gloss, superior leveling', preSelect: false },
      { name: 'Luna Grey Scuff Pads (Pack of 3)',   desc: 'Surface prep and scuffing',               preSelect: true },
      { name: 'Luna UHS Primer 1.25L Kit',          desc: 'For bare metal, dents, or imperfections', preSelect: true },
      { name: 'Q1 Masking Tape 1.5"',               desc: 'For clean paint lines',                   preSelect: false },
      { name: 'Q1 Masking Tape 3/4"',               desc: 'For tight curves and detail work',        preSelect: false },
      { name: 'Tape and Drape',                     desc: 'Protect surrounding areas',               preSelect: false },
      { name: '3M Respirator',                      desc: 'Protect yourself from fumes',             preSelect: false }
    ],
    wheels: [
      { name: 'Luna 2K Clearcoat Aerosol',          desc: 'Protection + high gloss finish',          preSelect: true, quantity: 2 },
      { name: 'Luna Grey Scuff Pads (Pack of 3)',   desc: 'Surface prep and scuffing',               preSelect: true },
      { name: 'Adhesion Promoter / UltraGrip',      desc: 'Recommended for wheel surfaces',          preSelect: false },
      { name: 'Luna 1KEpoxy Primer Aerosol',        desc: 'For bare/sanded wheels',                  preSelect: false },
      { name: 'Luna XPressBuild Primer Filler',     desc: 'Fills scratches and imperfections',       preSelect: false },
      { name: 'Q1 Masking Tape 1.5"',               desc: 'For clean paint lines',                   preSelect: false },
      { name: 'Q1 Masking Tape 3/4"',               desc: 'For tight curves and detail work',        preSelect: false },
      { name: 'Tape and Drape',                     desc: 'Protect surrounding areas',               preSelect: false },
      { name: '3M Respirator',                      desc: 'Protect yourself from fumes',             preSelect: false }
    ],
    motorcycle_few_parts: [
      { name: 'Luna 2K Clearcoat Aerosol',          desc: 'Protection + high gloss finish',          preSelect: true },
      { name: 'Luna Grey Scuff Pads (Pack of 3)',   desc: 'Surface prep and scuffing',               preSelect: true },
      { name: 'Luna 1KEpoxy Primer Aerosol',        desc: 'For bare metal adhesion',                 preSelect: true },
      { name: 'Luna XPressBuild Primer Filler',     desc: 'Fills scratches and imperfections',       preSelect: false },
      { name: 'Luna ProMatt Clear Aerosol',         desc: 'For a matte/satin finish instead',        preSelect: false },
      { name: 'Q1 Masking Tape 1.5"',               desc: 'For clean paint lines',                   preSelect: false },
      { name: 'Q1 Masking Tape 3/4"',               desc: 'For tight curves and detail work',        preSelect: false },
      { name: 'Tape and Drape',                     desc: 'Protect surrounding areas',               preSelect: false },
      { name: '3M Respirator',                      desc: 'Protect yourself from fumes',             preSelect: false }
    ],
    motorcycle_sport: [
      { name: 'Luna Standard Clearcoat 4.7L Kit',   desc: 'Good durability, affordable option',      preSelect: true },
      { name: 'Luna VHS Crystal Clearcoat 5L Kit',  desc: 'Premium \u2014 deep gloss, superior leveling', preSelect: false },
      { name: 'Luna Grey Scuff Pads (Pack of 3)',   desc: 'Surface prep and scuffing',               preSelect: true },
      { name: 'Luna 1KEpoxy Primer Aerosol',        desc: 'For bare metal adhesion',                 preSelect: true },
      { name: 'Luna XPressBuild Primer Filler',     desc: 'Fills scratches and imperfections',       preSelect: false },
      { name: 'Luna ProMatt Clear Aerosol',         desc: 'For a matte/satin finish instead',        preSelect: false },
      { name: 'Q1 Masking Tape 1.5"',               desc: 'For clean paint lines',                   preSelect: false },
      { name: 'Q1 Masking Tape 3/4"',               desc: 'For tight curves and detail work',        preSelect: false },
      { name: 'Tape and Drape',                     desc: 'Protect surrounding areas',               preSelect: false },
      { name: '3M Respirator',                      desc: 'Protect yourself from fumes',             preSelect: false }
    ],
    motorcycle_tourer: [
      { name: 'Luna Standard Clearcoat 4.7L Kit',   desc: 'Good durability, affordable option',      preSelect: true },
      { name: 'Luna VHS Crystal Clearcoat 5L Kit',  desc: 'Premium \u2014 deep gloss, superior leveling', preSelect: false },
      { name: 'Luna Grey Scuff Pads (Pack of 3)',   desc: 'Surface prep and scuffing',               preSelect: true },
      { name: 'Luna 1KEpoxy Primer Aerosol',        desc: 'For bare metal adhesion',                 preSelect: true },
      { name: 'Luna XPressBuild Primer Filler',     desc: 'Fills scratches and imperfections',       preSelect: false },
      { name: 'Luna ProMatt Clear Aerosol',         desc: 'For a matte/satin finish instead',        preSelect: false },
      { name: 'Q1 Masking Tape 1.5"',               desc: 'For clean paint lines',                   preSelect: false },
      { name: 'Q1 Masking Tape 3/4"',               desc: 'For tight curves and detail work',        preSelect: false },
      { name: 'Tape and Drape',                     desc: 'Protect surrounding areas',               preSelect: false },
      { name: '3M Respirator',                      desc: 'Protect yourself from fumes',             preSelect: false }
    ],
    full_vehicle_small: [
      { name: 'Luna Standard Clearcoat 4.7L Kit',   desc: 'Good durability, affordable option',      preSelect: true },
      { name: 'Luna VHS Crystal Clearcoat 5L Kit',  desc: 'Premium \u2014 deep gloss, superior leveling', preSelect: false },
      { name: 'Luna Grey Scuff Pads (Pack of 3)',   desc: 'Surface prep and scuffing',               preSelect: true },
      { name: 'Luna UHS Primer 1.25L Kit',          desc: 'For bare metal, dents, or imperfections', preSelect: true },
      { name: 'Q1 Masking Tape 1.5"',               desc: 'For clean paint lines',                   preSelect: false },
      { name: 'Q1 Masking Tape 3/4"',               desc: 'For tight curves and detail work',        preSelect: false },
      { name: 'Tape and Drape',                     desc: 'Protect surrounding areas',               preSelect: false },
      { name: '3M Respirator',                      desc: 'Protect yourself from fumes',             preSelect: false }
    ],
    full_vehicle_medium: [
      { name: 'Luna Standard Clearcoat 4.7L Kit',   desc: 'Good durability, affordable option',      preSelect: true },
      { name: 'Luna VHS Crystal Clearcoat 5L Kit',  desc: 'Premium \u2014 deep gloss, superior leveling', preSelect: false },
      { name: 'Luna Grey Scuff Pads (Pack of 3)',   desc: 'Surface prep and scuffing',               preSelect: true },
      { name: 'Luna UHS Primer 4.5L Kit',           desc: 'For bare metal, dents, or imperfections', preSelect: true },
      { name: 'Q1 Masking Tape 1.5"',               desc: 'For clean paint lines',                   preSelect: false },
      { name: 'Q1 Masking Tape 3/4"',               desc: 'For tight curves and detail work',        preSelect: false },
      { name: 'Tape and Drape',                     desc: 'Protect surrounding areas',               preSelect: false },
      { name: '3M Respirator',                      desc: 'Protect yourself from fumes',             preSelect: false }
    ],
    full_vehicle_large: [
      { name: 'Luna Standard Clearcoat 4.7L Kit',   desc: 'Good durability, affordable option',      preSelect: true },
      { name: 'Luna VHS Crystal Clearcoat 5L Kit',  desc: 'Premium \u2014 deep gloss, superior leveling', preSelect: false },
      { name: 'Luna Grey Scuff Pads (Pack of 3)',   desc: 'Surface prep and scuffing',               preSelect: true },
      { name: 'Luna UHS Primer 4.5L Kit',           desc: 'For bare metal, dents, or imperfections', preSelect: true },
      { name: 'Q1 Masking Tape 1.5"',               desc: 'For clean paint lines',                   preSelect: false },
      { name: 'Q1 Masking Tape 3/4"',               desc: 'For tight curves and detail work',        preSelect: false },
      { name: 'Tape and Drape',                     desc: 'Protect surrounding areas',               preSelect: false },
      { name: '3M Respirator',                      desc: 'Protect yourself from fumes',             preSelect: false }
    ],
    full_vehicle_xl: [
      { name: 'Luna Standard Clearcoat 4.7L Kit',   desc: 'Good durability, affordable option',      preSelect: true },
      { name: 'Luna VHS Crystal Clearcoat 5L Kit',  desc: 'Premium \u2014 deep gloss, superior leveling', preSelect: false },
      { name: 'Luna Grey Scuff Pads (Pack of 3)',   desc: 'Surface prep and scuffing',               preSelect: true },
      { name: 'Luna UHS Primer 4.5L Kit',           desc: 'For bare metal, dents, or imperfections', preSelect: true },
      { name: 'Q1 Masking Tape 1.5"',               desc: 'For clean paint lines',                   preSelect: false },
      { name: 'Q1 Masking Tape 3/4"',               desc: 'For tight curves and detail work',        preSelect: false },
      { name: 'Tape and Drape',                     desc: 'Protect surrounding areas',               preSelect: false },
      { name: '3M Respirator',                      desc: 'Protect yourself from fumes',             preSelect: false }
    ]
  };

  /* ─── Project Type Labels (for display in badges) ──────────────────── */

  var TYPE_LABELS = {
    chip_scratch: 'Chip / Scratch',
    bumper_bare: 'Bumper \u2014 Bare Plastic',
    bumper_repair: 'Bumper \u2014 Repair Damage',
    bumper_respray: 'Bumper \u2014 Respray Only',
    small_repair: 'Small Repair Area',
    single_panel_bare: 'Single Panel \u2014 Bare Metal',
    single_panel_repair: 'Single Panel \u2014 Repair',
    single_panel_respray: 'Single Panel \u2014 Respray',
    multiple_panels: 'Multiple Panels',
    full_vehicle_small: 'Full Vehicle \u2014 Small',
    full_vehicle_medium: 'Full Vehicle \u2014 Medium',
    full_vehicle_large: 'Full Vehicle \u2014 Large',
    full_vehicle_xl: 'Full Vehicle \u2014 XL',
    wheels: 'Wheels',
    motorcycle_few_parts: 'Motorcycle \u2014 A Few Parts',
    motorcycle_sport: 'Motorcycle \u2014 Sports Bike',
    motorcycle_tourer: 'Motorcycle \u2014 Tourer'
  };

  /* ─── Helper: Create Element ───────────────────────────────────────── */

  function el(tag, cls, html) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (html) node.innerHTML = html;
    return node;
  }

  /* ─── Helper: Format cart items for display ────────────────────────── */

  function formatCartItems(guide) {
    if (!guide.cartItems) return '1x ' + guide.size;
    return guide.cartItems.map(function (ci) {
      return ci.quantity + 'x ' + ci.sizeOption;
    }).join(' + ');
  }

  /* ─── Image Resize (client-side before API upload) ─────────────────── */

  function resizeImage(file, maxSize, callback, onFail) {
    var reader = new FileReader();
    reader.onload = function (e) {
      var img = new Image();
      img.onload = function () {
        var w = img.width, h = img.height;
        if (w > maxSize || h > maxSize) {
          var ratio = maxSize / Math.max(w, h);
          w = Math.round(w * ratio);
          h = Math.round(h * ratio);
        }
        var canvas = document.createElement('canvas');
        canvas.width = w;
        canvas.height = h;
        canvas.getContext('2d').drawImage(img, 0, 0, w, h);
        callback(canvas.toDataURL('image/jpeg', 0.8));
      };
      // Fires when the browser has no decoder for the format (e.g. HEIC on
      // Chrome/Firefox) — without it the flow hung silently forever.
      img.onerror = function () { if (onFail) onFail(); };
      img.src = e.target.result;
    };
    reader.onerror = function () { if (onFail) onFail(); };
    reader.readAsDataURL(file);
  }

  /* ─── HEIC support (iPhone photos) ─────────────────────────────────── */
  /* Safari decodes HEIC natively, so the normal <img> path just works.
     Chrome/Firefox/Android can't — for those we lazy-load heic2any (self-
     hosted theme asset, ~330KB gzipped, fetched ONLY when an actual HEIC
     needs converting) and transcode to JPEG client-side. */

  function isHeicFile(file) {
    var t = (file.type || '').toLowerCase();
    if (t.indexOf('image/heic') === 0 || t.indexOf('image/heif') === 0) return true;
    // iOS/Files often hands over HEIC with an EMPTY type — check the name
    return /\.hei[cf]$/i.test(file.name || '');
  }

  var heicLibPromise = null;
  function loadHeicLib() {
    if (window.heic2any) return Promise.resolve();
    if (heicLibPromise) return heicLibPromise;
    // Derive the theme-asset URL from our own script tag (asset URLs are
    // versioned, so we can't hardcode); fall back to jsDelivr if missing.
    var own = document.querySelector('script[src*="oem-build-kit"]');
    var assetSrc = own ? own.src.replace(/oem-build-kit\.js.*$/, 'oem-heic2any.min.js') : null;
    var cdnSrc = 'https://cdn.jsdelivr.net/npm/heic2any@0.0.4/dist/heic2any.min.js';
    function inject(src) {
      return new Promise(function (resolve, reject) {
        var s = document.createElement('script');
        s.src = src;
        s.onload = resolve;
        s.onerror = reject;
        document.head.appendChild(s);
      });
    }
    heicLibPromise = (assetSrc ? inject(assetSrc).catch(function () { return inject(cdnSrc); }) : inject(cdnSrc))
      .catch(function (err) { heicLibPromise = null; throw err; });
    return heicLibPromise;
  }

  /* ─── Build Upload Zone (AI image analysis) ──────────────────────── */

  function buildUploadZone(state, onSelect, gridEl) {
    var wrap = el('div', 'oem-byk-upload');
    var dropzone = el('div', 'oem-byk-upload__dropzone');
    dropzone.setAttribute('data-byk-dropzone', '');

    var fileInput = document.createElement('input');
    fileInput.type = 'file';
    // Explicit .heic/.heif so iOS offers existing photos untranscoded; no
    // `capture` attr — it forced the camera and blocked library picks.
    fileInput.accept = 'image/*,.heic,.heif';
    fileInput.style.display = 'none';

    function showPrompt() {
      dropzone.innerHTML = '';
      dropzone.className = 'oem-byk-upload__dropzone';
      var prompt = el('div', 'oem-byk-upload__prompt');
      prompt.innerHTML =
        svg('camera', 24) +
        '<p class="oem-byk-upload__title">Upload a Photo</p>' +
        '<p class="oem-byk-upload__subtitle">AI will suggest the right project type</p>';
      dropzone.appendChild(prompt);
      dropzone.appendChild(fileInput);
    }

    function showAnalyzing(dataUrl, message) {
      dropzone.innerHTML = '';
      dropzone.className = 'oem-byk-upload__dropzone oem-byk-upload__dropzone--has-preview';
      var preview = el('div', 'oem-byk-upload__preview');
      // No thumb while a HEIC is still being converted — neutral tile instead
      var thumb = dataUrl
        ? '<img class="oem-byk-upload__thumb oem-byk-upload__analyzing" src="' + dataUrl + '" alt="Uploaded photo">'
        : '<div class="oem-byk-upload__thumb oem-byk-upload__analyzing" style="background:var(--oem-muted,#ececf0);display:flex;align-items:center;justify-content:center;color:#9ca3af;">' + svg('camera', 20) + '</div>';
      preview.innerHTML =
        thumb +
        '<div class="oem-byk-upload__result">' +
          '<p class="oem-byk-upload__reason">' + svg('sparkles', 14) + ' ' + (message || 'Analyzing your photo...') + '</p>' +
        '</div>';
      dropzone.appendChild(preview);
      dropzone.appendChild(fileInput);
    }

    function showResult(dataUrl, result) {
      dropzone.innerHTML = '';
      dropzone.className = 'oem-byk-upload__dropzone oem-byk-upload__dropzone--has-preview';
      var preview = el('div', 'oem-byk-upload__preview');

      var projectLabel = TYPE_LABELS[result.projectId] || result.projectId || '';
      var confClass = 'oem-byk-upload__confidence--' + (result.confidence || 'low');

      preview.innerHTML =
        '<img class="oem-byk-upload__thumb" src="' + dataUrl + '" alt="Uploaded photo">' +
        '<div class="oem-byk-upload__result">' +
          '<p class="oem-byk-upload__reason">' + (result.reason || '') + '</p>' +
          (result.projectId
            ? '<p class="oem-byk-upload__suggestion">' +
                svg('sparkles', 12) + ' <strong>' + projectLabel + '</strong>' +
                ' <span class="oem-byk-upload__confidence ' + confClass + '">' + (result.confidence || '') + '</span>' +
              '</p>'
            : '') +
        '</div>';
      dropzone.appendChild(preview);

      if (result.projectId) {
        var actions = el('div', 'oem-byk-upload__actions');

        var useBtn = el('button', 'oem-byk-upload__use-btn', svg('check', 14) + ' Use this suggestion');
        useBtn.type = 'button';
        useBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          onSelect(result.projectId);
        });
        actions.appendChild(useBtn);

        var retryBtn = el('button', 'oem-byk-upload__retry-btn', 'Upload different photo');
        retryBtn.type = 'button';
        retryBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          clearSuggestion(gridEl);
          showPrompt();
        });
        actions.appendChild(retryBtn);

        dropzone.appendChild(actions);
      } else {
        var retryBtn2 = el('button', 'oem-byk-upload__retry-btn', 'Try a different photo');
        retryBtn2.type = 'button';
        retryBtn2.addEventListener('click', function (e) {
          e.stopPropagation();
          showPrompt();
        });
        dropzone.appendChild(retryBtn2);
      }
      dropzone.appendChild(fileInput);
    }

    function showError(dataUrl) {
      dropzone.innerHTML = '';
      dropzone.className = 'oem-byk-upload__dropzone oem-byk-upload__dropzone--has-preview';
      var preview = el('div', 'oem-byk-upload__preview');
      var errThumb = dataUrl
        ? '<img class="oem-byk-upload__thumb" src="' + dataUrl + '" alt="Uploaded photo">'
        : '<div class="oem-byk-upload__thumb" style="background:var(--oem-muted,#ececf0);display:flex;align-items:center;justify-content:center;color:#9ca3af;">' + svg('camera', 20) + '</div>';
      preview.innerHTML =
        errThumb +
        '<div class="oem-byk-upload__result">' +
          '<p class="oem-byk-upload__reason">' + svg('alertcircle', 14) + ' Could not analyze image. Please select manually.</p>' +
        '</div>';
      dropzone.appendChild(preview);

      var retryBtn = el('button', 'oem-byk-upload__retry-btn', 'Try again');
      retryBtn.type = 'button';
      retryBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        showPrompt();
      });
      dropzone.appendChild(retryBtn);
      dropzone.appendChild(fileInput);
    }

    function runAnalysis(dataUrl) {
      state.uploadDataUrl = dataUrl;
      showAnalyzing(dataUrl);

      fetch(API_BASE + '/api/build-kit-analyze', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ image: dataUrl })
      })
        .then(function (res) { return res.json(); })
        .then(function (result) {
          state.aiSuggestion = result;
          showResult(dataUrl, result);

          if (result.projectId && gridEl) {
            highlightSuggestion(gridEl, result.projectId);
          }
        })
        .catch(function () {
          showError(dataUrl);
        });
    }

    function handleFile(file) {
      // HEIC often arrives with an EMPTY type — the old startsWith('image/')
      // gate silently dropped every one of those
      if (!file) return;
      if (!(file.type && file.type.indexOf('image/') === 0) && !isHeicFile(file)) return;

      resizeImage(file, 1024, runAnalysis, function () {
        // Browser couldn't decode it natively. If it's an iPhone HEIC,
        // transcode to JPEG with heic2any and run the same pipeline.
        if (!isHeicFile(file)) { showError(''); return; }
        showAnalyzing(null, 'Converting iPhone photo…');
        loadHeicLib()
          .then(function () {
            return window.heic2any({ blob: file, toType: 'image/jpeg', quality: 0.85 });
          })
          .then(function (out) {
            var jpeg = Array.isArray(out) ? out[0] : out;
            resizeImage(jpeg, 1024, runAnalysis, function () { showError(''); });
          })
          .catch(function () {
            showError('');
          });
      });
    }

    dropzone.addEventListener('click', function (e) {
      if (e.target.closest('.oem-byk-upload__use-btn') ||
          e.target.closest('.oem-byk-upload__retry-btn')) return;
      fileInput.click();
    });

    fileInput.addEventListener('change', function () {
      if (fileInput.files && fileInput.files[0]) {
        handleFile(fileInput.files[0]);
        fileInput.value = '';
      }
    });

    dropzone.addEventListener('dragover', function (e) {
      e.preventDefault();
      dropzone.classList.add('oem-byk-upload__dropzone--dragover');
    });
    dropzone.addEventListener('dragleave', function () {
      dropzone.classList.remove('oem-byk-upload__dropzone--dragover');
    });
    dropzone.addEventListener('drop', function (e) {
      e.preventDefault();
      dropzone.classList.remove('oem-byk-upload__dropzone--dragover');
      if (e.dataTransfer.files && e.dataTransfer.files[0]) {
        handleFile(e.dataTransfer.files[0]);
      }
    });

    showPrompt();
    wrap.appendChild(dropzone);
    return wrap;
  }

  /* ─── Suggestion Highlight Helpers ───────────────────────────────── */

  /* Map parent-level AI suggestions to default sub-type in flat grid */
  var AI_SUGGESTION_MAP = {
    bumper: 'bumper_repair',
    single_panel: 'single_panel_repair'
  };

  function highlightSuggestion(gridEl, projectId) {
    var btns = gridEl.querySelectorAll('.oem-byk-project');
    for (var i = 0; i < btns.length; i++) {
      btns[i].classList.remove('oem-byk-project--suggested');
    }
    var resolvedId = AI_SUGGESTION_MAP[projectId] || projectId;
    var allBtns = gridEl.querySelectorAll('.oem-byk-project');
    for (var j = 0; j < PROJECT_TYPES.length && j < allBtns.length; j++) {
      if (PROJECT_TYPES[j].id === resolvedId) {
        allBtns[j].classList.add('oem-byk-project--suggested');
        allBtns[j].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        break;
      }
    }
  }

  function clearSuggestion(gridEl) {
    if (!gridEl) return;
    var btns = gridEl.querySelectorAll('.oem-byk-project--suggested');
    for (var i = 0; i < btns.length; i++) {
      btns[i].classList.remove('oem-byk-project--suggested');
    }
  }

  /* ─── Build Project Grid (Step 1) ──────────────────────────────────── */

  function buildProjectGrid(state, onSelect) {
    var container = el('div', 'oem-byk-select-step');
    var grid = el('div', 'oem-byk-grid');

    PROJECT_TYPES.forEach(function (project) {
      var btn = el('button', 'oem-byk-project' + (state.selected === project.id ? ' oem-byk-project--selected' : ''));
      btn.type = 'button';

      var inner = '';
      if (project.popular) {
        inner += '<span class="oem-byk-project__popular">Popular</span>';
      }
      inner += '<div class="oem-byk-project__icon">' + svg(project.icon) + '</div>';
      inner += '<div class="oem-byk-project__info">';
      inner += '<p class="oem-byk-project__title">' + project.title + '</p>';
      inner += '<p class="oem-byk-project__desc">' + project.desc + '</p>';
      inner += '</div>';
      btn.innerHTML = inner;

      btn.addEventListener('click', function () {
        onSelect(project.id);
      });

      grid.appendChild(btn);
    });

    var uploadZone = buildUploadZone(state, onSelect, grid);
    container.appendChild(uploadZone);
    container.appendChild(grid);

    if (state.aiSuggestion && state.aiSuggestion.projectId) {
      setTimeout(function () {
        highlightSuggestion(grid, state.aiSuggestion.projectId);
      }, 50);
    }

    return container;
  }

  /* ─── Build Sub-Type Step (Step 1b) ──────────────────────────────── */

  function buildSubTypeStep(parentId, state, onSelect, onBack) {
    var subConfig = SUB_TYPES[parentId];
    if (!subConfig) return null;

    var container = el('div', 'oem-byk-substep');

    // Header with back
    var header = el('div', 'oem-byk-substep__header');
    var backBtn = el('button', 'oem-byk-back', svg('chevronleft', 16));
    backBtn.type = 'button';
    backBtn.addEventListener('click', onBack);
    header.appendChild(backBtn);

    var parentType = null;
    for (var i = 0; i < PROJECT_TYPES.length; i++) {
      if (PROJECT_TYPES[i].id === parentId) { parentType = PROJECT_TYPES[i]; break; }
    }
    var title = el('h3', 'oem-byk-substep__title', (parentType ? parentType.title : '') + ': ' + subConfig.prompt);
    header.appendChild(title);
    container.appendChild(header);

    // Image grid layout (vehicle sizes) or text chip layout (motorcycle)
    var isImageGrid = subConfig.layout === 'image-grid';
    var chipGrid = el('div', isImageGrid ? 'oem-byk-size-grid' : 'oem-byk-chip-grid');

    subConfig.chips.forEach(function (chip) {
      if (isImageGrid && chip.image) {
        var btn = el('button', 'oem-byk-size-card');
        btn.type = 'button';
        btn.innerHTML =
          '<div class="oem-byk-size-card__image"><img src="' + chip.image + '" alt="' + chip.label + '" loading="lazy" /></div>' +
          '<p class="oem-byk-size-card__label">' + chip.label + '</p>' +
          '<p class="oem-byk-size-card__desc">' + chip.desc + '</p>';
        btn.addEventListener('click', function () { onSelect(chip.key); });
        chipGrid.appendChild(btn);
      } else {
        var btn = el('button', 'oem-byk-chip');
        btn.type = 'button';
        btn.innerHTML =
          '<p class="oem-byk-chip__label">' + chip.label + '</p>' +
          '<p class="oem-byk-chip__desc">' + chip.desc + '</p>';
        btn.addEventListener('click', function () { onSelect(chip.key); });
        chipGrid.appendChild(btn);
      }
    });
    container.appendChild(chipGrid);

    // Hint text for vehicle sizes
    if (isImageGrid) {
      var hint = el('p', 'oem-byk-substep__hint', 'Not sure? Pick the larger size.');
      container.appendChild(hint);
    }

    return container;
  }

  /* ─── Add-on API Cache ─────────────────────────────────────────────── */

  var addonCache = {}; // keyed by projectType

  function fetchAddons(projectType) {
    if (addonCache[projectType]) {
      return Promise.resolve(addonCache[projectType]);
    }
    return fetch(API_BASE + '/api/build-kit-addons?projectType=' + encodeURIComponent(projectType))
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.addons) {
          addonCache[projectType] = data.addons;
          return data.addons;
        }
        return [];
      })
      .catch(function (err) {
        console.error('[oem-build-kit] Failed to fetch add-ons:', err);
        return [];
      });
  }

  /* ─── Build Add-ons Step (Step 2) ──────────────────────────────────── */

  function buildAddOnsStep(state, onBack) {
    var projectId = state.finalType;
    var guide = SIZE_GUIDE[projectId];
    if (!guide) guide = SIZE_GUIDE['chip_scratch'];

    var container = el('div', 'oem-byk-addons');

    // Header: back + project badge
    var header = el('div', 'oem-byk-addons__header');
    var backBtn = el('button', 'oem-byk-back', svg('chevronleft', 16));
    backBtn.type = 'button';
    backBtn.addEventListener('click', onBack);
    header.appendChild(backBtn);

    var label = el('span', 'oem-byk-addons__project-label', 'Project:');
    header.appendChild(label);

    var badgeText = TYPE_LABELS[projectId] || projectId;
    var badge = el('span', 'oem-byk-addons__project-badge', badgeText);
    header.appendChild(badge);
    container.appendChild(header);

    // Recommendation card
    var sizeDisplay = formatCartItems(guide);
    var recCard = el('div', 'oem-byk-recommendation');
    recCard.innerHTML =
      '<div class="oem-byk-recommendation__header">' +
        '<span class="oem-byk-recommendation__label">Recommended</span>' +
        '<span class="oem-byk-recommendation__size">' + sizeDisplay + '</span>' +
      '</div>' +
      '<p class="oem-byk-recommendation__text">' + guide.text + '</p>';
    container.appendChild(recCard);

    if (projectId === 'chip_scratch') {
      var noClear = el('div', 'oem-byk-noclear');
      noClear.innerHTML = svg('check', 14) + '<span>No clearcoat needed: 1K Gloss formula dries glossy</span>';
      container.appendChild(noClear);
    }

    // Add-ons section
    var section = el('div');
    var sectionLabel = el('p', 'oem-byk-addons__section-label', 'Essential add-ons');
    section.appendChild(sectionLabel);

    var addonGrid = el('div', 'oem-byk-addon-grid');

    // Show loading skeletons
    for (var s = 0; s < 6; s++) {
      var skel = el('div', 'oem-byk-addon-skeleton');
      skel.innerHTML =
        '<div class="oem-byk-addon-skeleton__image"></div>' +
        '<div class="oem-byk-addon-skeleton__line"></div>' +
        '<div class="oem-byk-addon-skeleton__line oem-byk-addon-skeleton__line--short"></div>';
      addonGrid.appendChild(skel);
    }

    section.appendChild(addonGrid);
    container.appendChild(section);

    // CTA button (matches main PDP atc-enhanced style)
    var cta = el('button', 'oem-byk-cta atc-enhanced');
    cta.type = 'button';
    cta.disabled = true;
    cta.innerHTML = '<span class="atc-text">Loading\u2026</span>';
    container.appendChild(cta);

    // Fetch real products from API
    fetchAddons(projectId).then(function (addons) {
      /* Owner 2026-07: the 1K Clearcoat Pen is retired from kit recommendations. */
      if (addons && addons.length) addons = addons.filter(function (a) { return !/clearcoat pen/i.test((a && a.title) || ''); });
      if (!addons || !addons.length) {
        // Fallback: show KIT_RULES hardcoded data without images/prices
        addons = (KIT_RULES[projectId] || KIT_RULES['chip_scratch']).map(function (a, i) {
          return {
            catalogKey: 'fallback_' + i,
            variantId: null,
            handle: null,
            title: a.name,
            price: null,
            compareAtPrice: null,
            image: null,
            preSelect: a.preSelect,
            quantity: a.quantity || 1,
            desc: a.desc || ''
          };
        });
      }

      // Store addons on state for cart integration
      state.addons = addons;

      // Initialize checked set from preSelect
      if (!state.checkedIds) {
        state.checkedIds = {};
        addons.forEach(function (a, idx) {
          if (a.preSelect) state.checkedIds[idx] = true;
        });
      }

      // Replace skeletons with real cards
      addonGrid.innerHTML = '';

      addons.forEach(function (addon, idx) {
        var isChecked = !!state.checkedIds[idx];
        var card = el('button', 'oem-byk-addon' + (isChecked ? ' oem-byk-addon--checked' : ''));
        card.type = 'button';

        var qtyLabel = (addon.quantity && addon.quantity > 1) ? '<span class="oem-byk-addon__qty">' + addon.quantity + 'x</span>' : '';
        var priceHtml = addon.price ? '<p class="oem-byk-addon__price">$' + parseFloat(addon.price).toFixed(2) + '</p>' : '';
        var imageHtml = addon.image
          ? '<div class="oem-byk-addon__image"><img src="' + addon.image + '&width=200" alt="' + addon.title + '" loading="lazy"></div>'
          : '<div class="oem-byk-addon__image"><div style="width:100%;height:100%;background:var(--oem-muted,#ececf0);border-radius:6px;display:flex;align-items:center;justify-content:center;color:#9ca3af;font-size:11px;">No image</div></div>';

        // Owner 2026-07: the desc no longer renders as an always-visible
        // subtitle — it moves into an info-icon popover (data-oem-info, the
        // shared oem-pdp-blocks.js handler) to keep the cards compact.
        var escAttr = function (v) { return String(v).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); };
        var infoHtml = addon.desc
          ? '<span class="oem-byk-addon__info" role="button" tabindex="0" aria-label="More info" data-oem-info="' + escAttr(addon.desc) + '">' + svg('info', 14) + '</span>'
          : '';
        card.innerHTML =
          '<div class="oem-byk-addon__check">' + svg('check', 12) + '</div>' +
          imageHtml +
          '<p class="oem-byk-addon__name">' + qtyLabel + addon.title + infoHtml + '</p>' +
          priceHtml;

        card.addEventListener('click', function (ev) {
          if (ev && ev.target && ev.target.closest && ev.target.closest('[data-oem-info]')) return; // info tap = popover only
          if (state.checkedIds[idx]) {
            delete state.checkedIds[idx];
            card.classList.remove('oem-byk-addon--checked');
          } else {
            state.checkedIds[idx] = true;
            card.classList.add('oem-byk-addon--checked');
          }
          updateCTA();
        });

        addonGrid.appendChild(card);
      });

      // Enable and update CTA
      cta.disabled = false;
      updateCTA();

      // Update variant badges with recommended sizes
      updateVariantBadges(guide);

      // Select the primary recommended size on the variant selector
      if (window.OEMVariantBadges && window.OEMVariantBadges.selectSize && guide.size) {
        window.OEMVariantBadges.selectSize(guide.size);
      }

      // Kit-active mode: relabel the main PDP button "Add paint only". Its
      // submit is NOT intercepted — the theme's native handler adds just the
      // selected paint variant at the form's quantity. The kit CTA below is
      // the ONLY path that adds the kit + add-ons.
      enterKitActiveMode();

      function calcTotalPrice() {
        var total = 0;

        // Basecoat price from Liquid variant JSON (prices in cents)
        var variantData = getProductVariants();
        if (variantData && guide.cartItems) {
          guide.cartItems.forEach(function (ci) {
            var variant = findVariantBySize(variantData, ci.sizeOption);
            if (variant && variant.price) {
              total += (variant.price / 100) * ci.quantity;
            }
          });
        } else if (variantData) {
          // Mirror the CTA: price the RECOMMENDED size, not the PDP selection
          var recV = findVariantBySize(variantData, guide.size);
          if (recV && recV.price) {
            total += recV.price / 100;
          } else {
            var selectedId = getSelectedVariantId();
            if (selectedId) {
              for (var vi = 0; vi < variantData.length; vi++) {
                if (variantData[vi].id === selectedId && variantData[vi].price) {
                  total += variantData[vi].price / 100;
                  break;
                }
              }
            }
          }
        }

        // Add-on prices (from API, decimal strings like "49.99")
        Object.keys(state.checkedIds).forEach(function (idx) {
          var addon = addons[parseInt(idx, 10)];
          if (addon && addon.price) {
            total += parseFloat(addon.price) * (addon.quantity || 1);
          }
        });

        return total;
      }

      function countItems() {
        var count = 0;
        // Basecoat items
        if (guide.cartItems) {
          guide.cartItems.forEach(function (ci) { count += ci.quantity; });
        } else {
          count += 1;
        }
        // Checked add-ons
        Object.keys(state.checkedIds).forEach(function (idx) {
          var addon = addons[parseInt(idx, 10)];
          count += (addon && addon.quantity) ? addon.quantity : 1;
        });
        return count;
      }

      function updateCTA() {
        var total = calcTotalPrice();
        var itemCount = countItems();
        var priceStr = total > 0 ? '$' + total.toFixed(2) : '';
        cta.innerHTML =
          '<span class="atc-qty">' + itemCount + '</span>' +
          '<span class="atc-text">Add ' + itemCount + ' Item' + (itemCount !== 1 ? 's' : '') + '</span>' +
          '<span class="atc-price">' + priceStr + '</span>';
        // NOTE: the main PDP button is intentionally NOT synced with kit
        // selections — it reads "Add paint only" and its native submit adds
        // only the selected paint variant (see enterKitActiveMode).
        if (typeof updateFloatBar === 'function') updateFloatBar(); // keep the floating kit bar in sync
      }

      // CTA click → add to cart
      cta.onclick = function () {
        if (cta.disabled) return;

        var items = [];

        // 1. Add the basecoat (current PDP product) variant(s)
        var variantData = getProductVariants();
        if (variantData && guide.cartItems) {
          guide.cartItems.forEach(function (ci) {
            var variant = findVariantBySize(variantData, ci.sizeOption);
            if (variant) {
              items.push({ id: extractNumericId(variant.id), quantity: ci.quantity });
            }
          });
        } else if (variantData) {
          // cartItems:null guides — add the RECOMMENDED size (what the UI
          // shows), falling back to the PDP-selected variant on a mismatch.
          var recVariant = findVariantBySize(variantData, guide.size);
          var paintId = recVariant ? extractNumericId(recVariant.id) : getSelectedVariantId();
          if (paintId) {
            items.push({ id: paintId, quantity: 1 });
          }
        }

        // 2. Add checked add-ons
        Object.keys(state.checkedIds).forEach(function (idx) {
          var addon = addons[parseInt(idx, 10)];
          if (addon && addon.variantId) {
            items.push({ id: extractNumericId(addon.variantId), quantity: addon.quantity || 1 });
          }
        });

        if (!items.length) {
          console.warn('[oem-build-kit] No items to add to cart');
          return;
        }

        // Disable CTA while adding
        cta.disabled = true;
        cta.innerHTML = '<span class="atc-text">Adding\u2026</span>';

        addToCart(items).then(function () {
          cta.disabled = false;
          cta.innerHTML = '<span class="atc-text">Added to Cart! ✓</span>';
          var itemCount = items.reduce(function (n, it) { return n + (it.quantity || 1); }, 0);
          // Owner UX (2026-07): brief "Added ✓" flash → close the kit panel →
          // open the cart drawer showing everything that landed. Falls back to
          // the theme's DYCToast (same pattern as product-form.js) if the
          // drawer isn't on the page.
          setTimeout(function () {
            var openTrigger = document.querySelector('[data-oem-byk-trigger][data-open="true"]');
            var openPanel = openTrigger ? openTrigger.closest('[data-oem-byk]').querySelector('.oem-byk-panel') : null;
            if (openTrigger && openPanel) toggleDesktopPanel(openTrigger, openPanel);
            var drawer = document.querySelector('cart-drawer');
            if (drawer && typeof drawer.show === 'function') {
              // The drawer's DOM is whatever was server-rendered at page load —
              // the cartUpdate publish only syncs the badge. Pull fresh section
              // HTML so it opens SHOWING the kit that was just added.
              if (typeof drawer._refreshSections === 'function') drawer._refreshSections();
              drawer.show();
            } else if (window.DYCToast) {
              DYCToast.show({
                type: 'success',
                title: 'Kit added to cart',
                desc: itemCount + ' item' + (itemCount !== 1 ? 's' : '') + ' added',
                actionText: 'View Cart →',
                action: function () {
                  var d = document.querySelector('cart-drawer');
                  if (d && typeof d.show === 'function') d.show();
                  else window.location = '/cart';
                }
              });
            }
            updateCTA();
          }, 450);
        }).catch(function (err) {
          console.error('[oem-build-kit] Cart error:', err);
          cta.disabled = false;
          cta.innerHTML = '<span class="atc-text">Error \u2013 Try Again</span>';
          setTimeout(function () { updateCTA(); }, 3000);
        });
      };

      /* \u2500\u2500 Floating kit bar (SunGod Add-to-Bag pattern, owner 2026-07) \u2500\u2500
         Fixed to the viewport bottom while the kit step is on screen: shows
         what the kit holds (count + total, expandable line-items) + Add.
         Slides down out of view whenever the REAL CTA above is visible \u2014
         measured on sungod.co: bar always in DOM, translateY(its height)
         toggled by an observer on the main button. */
      /* ── "Included in your kit" strip (owner 2026-07): the CTA count includes
         the paint (e.g. "2x Aerosol") but nothing VISIBLE showed it — make the
         paint line items explicit right above the button. */
      var oldInc = container.querySelector('.oem-byk-included');
      if (oldInc) oldInc.remove();
      var variantDataInc = getProductVariants();
      var incLines = (guide.cartItems && guide.cartItems.length)
        ? guide.cartItems
        : (guide.size ? [{ sizeOption: guide.size, quantity: 1 }] : []);
      if (incLines.length) {
        var included = el('div', 'oem-byk-included');
        included.appendChild(el('div', 'oem-byk-included__label', 'Included in your kit'));
        incLines.forEach(function (ci) {
          if (!ci || !ci.sizeOption) return;
          var v = variantDataInc ? findVariantBySize(variantDataInc, ci.sizeOption) : null;
          var priceStr = (v && v.price) ? '$' + ((v.price * (ci.quantity || 1)) / 100).toFixed(2) : '';
          var line = el('div', 'oem-byk-included__line');
          line.innerHTML = '<span class="oem-byk-included__check">' + svg('check', 10) + '</span>'
            + '<span class="oem-byk-included__name">' + (ci.quantity || 1) + '× ' + ci.sizeOption + ' basecoat</span>'
            + '<span class="oem-byk-included__price">' + priceStr + '</span>';
          included.appendChild(line);
        });
        container.insertBefore(included, cta);
      }

      var oldBar = document.querySelector('.oem-byk-floatbar');
      if (oldBar) oldBar.remove();
      var floatBar = el('div', 'oem-byk-floatbar oem-byk-floatbar--hidden');
      var fbList = el('div', 'oem-byk-floatbar__list');
      var fbMain = el('div', 'oem-byk-floatbar__main');
      var fbSummary = el('button', 'oem-byk-floatbar__summary');
      fbSummary.type = 'button';
      var fbAdd = el('button', 'oem-byk-floatbar__add');
      fbAdd.type = 'button';
      fbMain.appendChild(fbSummary);
      fbMain.appendChild(fbAdd);
      floatBar.appendChild(fbList);
      floatBar.appendChild(fbMain);
      document.body.appendChild(floatBar);

      function kitLines() {
        var lines = [];
        if (guide.cartItems) {
          guide.cartItems.forEach(function (ci) { lines.push({ q: ci.quantity || 1, t: ci.sizeOption + ' paint' }); });
        } else if (guide.size) {
          lines.push({ q: 1, t: guide.size + ' paint' });
        }
        Object.keys(state.checkedIds || {}).forEach(function (idx) {
          var a = addons[parseInt(idx, 10)];
          if (a) lines.push({ q: a.quantity || 1, t: a.title });
        });
        return lines;
      }

      function updateFloatBar() {
        // Guard: updateCTA fires during setup BEFORE the bar elements exist
        // (function is hoisted above the var assignments) — no-op until built.
        if (!fbSummary || !fbAdd || !fbList) return;
        var total = calcTotalPrice();
        var n = countItems();
        fbSummary.innerHTML = '<span class="fb-count">' + n + '</span>'
          + '<span class="fb-label">Your kit \u00b7 $' + total.toFixed(2) + '</span>'
          + '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m18 15-6-6-6 6"/></svg>';
        fbAdd.textContent = 'Add Kit';
        fbList.innerHTML = kitLines().map(function (l) {
          return '<div class="fb-line"><span>' + l.q + '\u00d7</span>' + l.t + '</div>';
        }).join('');
      }
      updateFloatBar();

      fbSummary.onclick = function () { floatBar.classList.toggle('oem-byk-floatbar--expanded'); };
      fbAdd.onclick = function () { cta.click(); };

      if ('IntersectionObserver' in window) {
        var fbIO = new IntersectionObserver(function (entries) {
          // real CTA on screen \u2192 slide the bar away (and collapse the list)
          var ctaVisible = entries[0].isIntersecting;
          floatBar.classList.toggle('oem-byk-floatbar--hidden', ctaVisible);
          if (ctaVisible) floatBar.classList.remove('oem-byk-floatbar--expanded');
        }, { threshold: 0.15 });
        fbIO.observe(cta);
      } else {
        floatBar.classList.remove('oem-byk-floatbar--hidden');
      }
    });

    return container;
  }

  /* ─── Cart Helpers ───────────────────────────────────────────────────── */

  function extractNumericId(gid) {
    // "gid://shopify/ProductVariant/12345" → 12345
    if (!gid) return null;
    var parts = String(gid).split('/');
    var num = parseInt(parts[parts.length - 1], 10);
    return isNaN(num) ? null : num;
  }

  function getProductVariants() {
    // Read variant data from Liquid-injected attribute on the block wrapper
    var wrap = document.querySelector('[data-oem-byk][data-product-variants]');
    if (!wrap) return null;
    try {
      return JSON.parse(wrap.getAttribute('data-product-variants'));
    } catch (e) {
      return null;
    }
  }

  function getMainCartForm(scope) {
    // The color-confirm block renders a hidden undercoat quick-add form
    // (#undercoatAddToCart) BEFORE the buy-buttons form in the product column,
    // so a bare querySelector('form[action*="/cart/add"]') returns the WRONG
    // product (the kit added undercoat instead of paint).
    var root = scope || document;
    var form = root.querySelector('mcc-product-form form[action*="/cart/add"]');
    if (form) return form;
    var forms = root.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      if (forms[i].id !== 'undercoatAddToCart' && !forms[i].closest('.oem-color-confirm')) return forms[i];
    }
    return null;
  }

  function getSelectedVariantId() {
    // Try to get the currently selected variant from the PDP form
    var form = getMainCartForm();
    var input = form ? form.querySelector('input[name="id"]') : null;
    if (input) return parseInt(input.value, 10) || null;

    // Fallback: URL param
    var params = new URLSearchParams(window.location.search);
    var vid = params.get('variant');
    return vid ? parseInt(vid, 10) : null;
  }

  function findVariantBySize(variants, sizeOption) {
    // variants = [{ id, title, option1, option2, ... }]
    if (!variants || !sizeOption) return null;
    var sizeLower = sizeOption.toLowerCase();
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      // Check title and all option fields
      if ((v.title || '').toLowerCase().indexOf(sizeLower) !== -1) return v;
      if ((v.option1 || '').toLowerCase().indexOf(sizeLower) !== -1) return v;
      if ((v.option2 || '').toLowerCase().indexOf(sizeLower) !== -1) return v;
      if ((v.option3 || '').toLowerCase().indexOf(sizeLower) !== -1) return v;
    }
    return null;
  }

  function addToCart(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('Cart add failed: ' + r.status);
      return r.json();
    }).then(function (data) {
      // Refresh the header count AND the drawer contents through the theme's
      // pub/sub — <cart-drawer> subscribes to PUB_SUB_EVENTS.cartUpdate and
      // re-fetches its section HTML (the old window.CartDrawer.open() path
      // never existed in this theme, which is why adds looked like nothing
      // happened until a refresh).
      fetch('/cart.js?_fd=0').then(function (r) { return r.json(); }).then(function (cart) {
        document.querySelectorAll('.cart-count-bubble span, [data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'oem-build-kit', cartData: cart });
        }
      }).catch(function () { /* count refresh is best-effort */ });
      return data;
    });
  }

  /* ─── Kit-Active Main-Button Treatment + Badge Updates ─────────────── */

  function getSectionId() {
    var el = document.querySelector('[id^="MainProduct-"]');
    return el ? el.getAttribute('data-section') : null;
  }

  function clearBYKExtras() {
    var sectionId = getSectionId();
    document.dispatchEvent(new CustomEvent('dyc:accessories-clear', {
      detail: { sectionId: sectionId || undefined }
    }));
    // Also clear variant badges
    if (window.OEMVariantBadges && window.OEMVariantBadges.clear) {
      window.OEMVariantBadges.clear();
    }
  }

  function updateVariantBadges(guide) {
    if (!window.OEMVariantBadges || !window.OEMVariantBadges.update) return;
    if (guide && guide.cartItems) {
      window.OEMVariantBadges.update(guide.cartItems);
    } else if (guide && guide.size) {
      // Single item — show 1x on the recommended size
      window.OEMVariantBadges.update([{ sizeOption: guide.size, quantity: 1 }]);
    }
  }

  /* Kit-active main-button treatment.
     SINGLE source of truth for "kit active": _bykKitActive. While true, the
     main PDP button is relabelled "Add paint only" \u2014 and its behavior
     genuinely IS paint-only, because the form is NOT intercepted: the theme's
     native submit adds just the currently selected variant at the form's
     quantity. The kit CTA (inside buildAddOnsStep) is the ONLY path that adds
     the kit + add-ons. Label and behavior can never diverge because both are
     simply "native form + swapped label", gated by this one flag. */
  var _bykKitActive = false;

  function enterKitActiveMode() {
    exitKitActiveMode(); // reset any prior treatment first

    var sectionId = getSectionId();
    if (!sectionId) return;

    var scope = document.getElementById('MainProduct-' + sectionId) || document;
    var form = getMainCartForm(scope) || getMainCartForm();
    if (!form) return;

    var mainBtn = form.querySelector('button[type="submit"], .add-cart-button');
    if (!mainBtn) return;

    _bykKitActive = true;
    mainBtn.classList.add('oem-byk-secondary-atc');
    var mainLabel = mainBtn.querySelector('.atc-text, .button-text') || mainBtn;
    if (!mainBtn.dataset.oemOrigLabel) mainBtn.dataset.oemOrigLabel = mainLabel.textContent;
    mainLabel.textContent = 'Add paint only';
  }

  function exitKitActiveMode() {
    if (!_bykKitActive) return;
    _bykKitActive = false;
    // Restore on all cart forms (we may not know which one carried the swap)
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      var btn = form.querySelector('button[type="submit"], .add-cart-button');
      if (btn && btn.dataset.oemOrigLabel) {
        var label = btn.querySelector('.atc-text, .button-text') || btn;
        label.textContent = btn.dataset.oemOrigLabel;
        delete btn.dataset.oemOrigLabel;
        btn.classList.remove('oem-byk-secondary-atc');
      }
    });
  }

  /* ─── Render Content Into Container (smooth transitions) ──────────── */

  function buildStepContent(contentEl, state, callbacks) {
    var frag = document.createDocumentFragment();

    if (state.step === 'select') {
      frag.appendChild(buildProjectGrid(state, function (id) {
        if (SUB_TYPES[id]) {
          state.selected = id;
          state.step = 'substep';
          if (callbacks.onStepChange) callbacks.onStepChange();
          renderStep(contentEl, state, callbacks);
        } else {
          state.selected = id;
          state.finalType = id;
          var guide = SIZE_GUIDE[state.finalType] || SIZE_GUIDE['chip_scratch'];
          document.dispatchEvent(new CustomEvent('oem:project-selected', {
            detail: { projectId: state.finalType, recommendedSize: guide.size }
          }));
          state.step = 'addons';
          state.checkedIds = null;
          if (callbacks.onStepChange) callbacks.onStepChange();
          renderStep(contentEl, state, callbacks);
        }
      }));
    } else if (state.step === 'substep') {
      var subStep = buildSubTypeStep(state.selected, state, function (subKey) {
        state.finalType = subKey;
        var guide = SIZE_GUIDE[state.finalType] || SIZE_GUIDE['chip_scratch'];
        document.dispatchEvent(new CustomEvent('oem:project-selected', {
          detail: { projectId: state.finalType, recommendedSize: guide.size }
        }));
        state.step = 'addons';
        state.checkedIds = null;
        if (callbacks.onStepChange) callbacks.onStepChange();
        renderStep(contentEl, state, callbacks);
      }, function () {
        state.step = 'select';
        state.selected = null;
        state.finalType = null;
        if (callbacks.onStepChange) callbacks.onStepChange();
        renderStep(contentEl, state, callbacks);
      });
      if (subStep) frag.appendChild(subStep);
    } else {
      frag.appendChild(buildAddOnsStep(state, function () {
        // Leaving addons step — clear kit badges/extras and the paint-only treatment
        clearBYKExtras();
        exitKitActiveMode();
        if (state.selected && SUB_TYPES[state.selected]) {
          state.step = 'substep';
          state.finalType = null;
          state.checkedIds = null;
        } else {
          state.step = 'select';
          state.selected = null;
          state.finalType = null;
          state.checkedIds = null;
        }
        if (callbacks.onStepChange) callbacks.onStepChange();
        renderStep(contentEl, state, callbacks);
      }));
    }
    return frag;
  }

  function renderStep(contentEl, state, callbacks) {
    // Any step change invalidates the floating kit bar — the addons step
    // recreates it; every other step must not leave a stale one behind.
    var staleBar = document.querySelector('.oem-byk-floatbar');
    if (staleBar) staleBar.remove();

    // Lock the current height to prevent layout jump
    var prevHeight = contentEl.scrollHeight;
    if (prevHeight > 0) {
      contentEl.style.minHeight = prevHeight + 'px';
      contentEl.style.overflow = 'hidden';
    }

    // Fade out existing content
    var oldChildren = contentEl.children;
    for (var i = 0; i < oldChildren.length; i++) {
      oldChildren[i].style.opacity = '0';
    }

    // Build new content offscreen
    var wrapper = el('div', 'oem-byk-step-enter');
    wrapper.appendChild(buildStepContent(contentEl, state, callbacks));

    // Short delay to let fade-out start, then swap
    setTimeout(function () {
      contentEl.innerHTML = '';
      contentEl.appendChild(wrapper);

      // Scroll to top of content area
      contentEl.scrollTop = 0;

      // Measure new height and animate
      requestAnimationFrame(function () {
        var newHeight = contentEl.scrollHeight;
        contentEl.style.transition = 'min-height 250ms ease';
        contentEl.style.minHeight = newHeight + 'px';

        // Trigger the enter animation
        requestAnimationFrame(function () {
          wrapper.classList.add('oem-byk-step-enter--active');
        });

        // Cleanup after transition
        setTimeout(function () {
          contentEl.style.minHeight = '';
          contentEl.style.overflow = '';
          contentEl.style.transition = '';
          // Desktop-only hook (see toggleDesktopPanel) — bring the panel back
          // into view after a step change (e.g. project select -> kit summary).
          // Mobile's callbacks object never sets this, so the bottom sheet
          // (an overlay) is correctly left untouched.
          if (callbacks && typeof callbacks.onSettled === 'function') callbacks.onSettled();
        }, 300);
      });
    }, 80);
  }

  /* ─── Step Title Helper ─────────────────────────────────────────────── */

  function getStepTitle(state) {
    if (state.step === 'select') return 'What are you working on?';
    if (state.step === 'substep') {
      var subConfig = SUB_TYPES[state.selected];
      return subConfig ? subConfig.prompt : 'Select option';
    }
    return 'Essential Add-ons';
  }

  function shouldShowBack(state) {
    return state.step === 'substep' || state.step === 'addons';
  }

  /* ─── Mobile Bottom Sheet ─────────────────────────────────────────── */

  var sheetOverlay = null;
  var sheetPanel = null;
  var sheetBody = null;
  var sheetTitle = null;
  var sheetBackBtn = null;

  function ensureSheet() {
    if (sheetOverlay) return;

    sheetOverlay = el('div', 'oem-byk-overlay');
    document.body.appendChild(sheetOverlay);

    sheetPanel = el('div', 'oem-byk-sheet');

    var handle = el('div', 'oem-byk-sheet__handle');
    handle.innerHTML = '<div class="oem-byk-sheet__handle-bar"></div>';
    sheetPanel.appendChild(handle);

    var header = el('div', 'oem-byk-sheet__header');
    var headerLeft = el('div', 'oem-byk-sheet__header-left');

    sheetBackBtn = el('button', 'oem-byk-back', svg('chevronleft', 16));
    sheetBackBtn.type = 'button';
    sheetBackBtn.style.display = 'none';
    headerLeft.appendChild(sheetBackBtn);

    var headerIcon = el('div', 'oem-byk-sheet__header-icon', svg('spraycan', 16));
    headerLeft.appendChild(headerIcon);

    sheetTitle = el('h3', 'oem-byk-sheet__title', 'What are you working on?');
    headerLeft.appendChild(sheetTitle);

    header.appendChild(headerLeft);

    var closeBtn = el('button', 'oem-byk-sheet__close', svg('x', 16));
    closeBtn.type = 'button';
    header.appendChild(closeBtn);

    sheetPanel.appendChild(header);

    sheetBody = el('div', 'oem-byk-sheet__body');
    sheetPanel.appendChild(sheetBody);

    document.body.appendChild(sheetPanel);

    sheetOverlay.addEventListener('click', closeMobileSheet);
    closeBtn.addEventListener('click', closeMobileSheet);
  }

  var mobileState = null;

  function updateSheetHeader() {
    if (!mobileState) return;
    sheetTitle.textContent = getStepTitle(mobileState);
    sheetBackBtn.style.display = shouldShowBack(mobileState) ? '' : 'none';
  }

  function mobileCallbacks() {
    return {
      onStepChange: function () {
        updateSheetHeader();
      }
    };
  }

  function openMobileSheet(trigger) {
    ensureSheet();

    mobileState = { step: 'select', selected: null, finalType: null, checkedIds: null };

    var scrollY = window.scrollY;
    document.body.setAttribute('scroll-locked', '');
    document.body.dataset.scrollY = scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + scrollY + 'px';
    document.body.style.width = '100%';

    updateSheetHeader();
    renderStep(sheetBody, mobileState, mobileCallbacks());

    sheetBackBtn.onclick = function () {
      if (mobileState.step === 'addons') {
        if (mobileState.selected && SUB_TYPES[mobileState.selected]) {
          mobileState.step = 'substep';
          mobileState.finalType = null;
          mobileState.checkedIds = null;
        } else {
          mobileState.step = 'select';
          mobileState.selected = null;
          mobileState.finalType = null;
          mobileState.checkedIds = null;
        }
      } else if (mobileState.step === 'substep') {
        mobileState.step = 'select';
        mobileState.selected = null;
        mobileState.finalType = null;
      }
      updateSheetHeader();
      renderStep(sheetBody, mobileState, mobileCallbacks());
    };

    requestAnimationFrame(function () {
      sheetOverlay.classList.add('oem-byk-overlay--visible');
      sheetPanel.classList.add('oem-byk-sheet--visible');
    });
  }

  function closeMobileSheet() {
    if (!sheetOverlay) return;

    // Clear kit badges/extras and the paint-only treatment when closing
    clearBYKExtras();
    exitKitActiveMode();

    sheetOverlay.classList.remove('oem-byk-overlay--visible');
    sheetPanel.classList.remove('oem-byk-sheet--visible');

    var scrollY = parseInt(document.body.dataset.scrollY || '0', 10);
    document.body.removeAttribute('scroll-locked');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollY);

    var triggers = document.querySelectorAll('[data-oem-byk-trigger]');
    triggers.forEach(function (t) { t.setAttribute('data-open', 'false'); });
  }

  /* ─── Desktop Inline Panel ────────────────────────────────────────── */

  function ensureInViewIfAvailable(el) {
    if (typeof window.ensureInView === 'function') window.ensureInView(el);
  }

  function toggleDesktopPanel(trigger, panel) {
    var isOpen = trigger.getAttribute('data-open') === 'true';
    var newOpen = !isOpen;

    // Closing the panel — clear kit badges/extras, the paint-only treatment,
    // and the floating kit bar.
    if (!newOpen) {
      clearBYKExtras();
      exitKitActiveMode();
      var fb = document.querySelector('.oem-byk-floatbar');
      if (fb) fb.remove();
    }

    trigger.setAttribute('data-open', String(newOpen));
    panel.setAttribute('data-open', String(newOpen));

    if (newOpen && !panel._bykState) {
      panel._bykState = { step: 'select', selected: null, finalType: null, checkedIds: null };
      var content = panel.querySelector('.oem-byk-panel__content');
      if (content) {
        renderStep(content, panel._bykState, {
          onStepChange: function () {},
          // Fires ~380ms later, after the freshly-rendered step's own content
          // animation settles — covers "step changes inside the open panel"
          // (project select -> kit summary, sub-type select -> add-ons, back).
          onSettled: function () { ensureInViewIfAvailable(panel); }
        });
      }
    } else if (newOpen && panel._bykState && panel._bykState.step === 'addons') {
      // Reopening a panel whose persisted state is still on the addons step —
      // the kit is active again, so reapply the paint-only treatment.
      enterKitActiveMode();
    }

    if (newOpen) {
      // Panel's own open reveal (grid-template-rows 0fr -> 1fr, 300ms — see
      // .oem-byk-panel in oem-build-kit.css). Covers EVERY reopen path,
      // including reopening while still on the 'select'/'substep' step where
      // neither branch above re-renders content (so onSettled never fires).
      setTimeout(function () { ensureInViewIfAvailable(panel); }, 320);
    }
  }

  /* ─── Init ────────────────────────────────────────────────────────── */

  function initBuildKit(scope) {
    var root = scope || document;
    var containers = root.querySelectorAll('[data-oem-byk]');

    containers.forEach(function (container) {
      var trigger = container.querySelector('[data-oem-byk-trigger]');
      var panel = container.querySelector('.oem-byk-panel');
      if (!trigger) return;

      if (trigger._bykInit) return;
      trigger._bykInit = true;

      trigger.addEventListener('click', function () {
        // Owner call (2026-07): one experience on every viewport — the inline
        // expand-in-place panel, same smooth reveal as the Vehicle Compatibility
        // card. The mobile bottom-sheet path (openMobileSheet/closeMobileSheet
        // above) is retired but kept in the file for an easy revert.
        if (panel) toggleDesktopPanel(trigger, panel);
      });
    });
  }

  /* ─── Bootstrap ──────────────────────────────────────────────────── */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initBuildKit(document); });
  } else {
    initBuildKit(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) initBuildKit(e.target);
  });

})();
